import React, { useState, useEffect } from "react";
import { getPath } from "../../utils";
import styled from "styled-components";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import RadioGroup from "sushiweb/RadioGroup";
import variables from "../../constants/assets/variables";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateEvQcDetails } from "../../store/actions/DlRcDetails";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Modal from "sushiweb/Modal";
import {
  FlexContainer,
  Heading,
  BorderedBox,
  Divider,
} from "../../constants/assets/containers";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Permission from "../Common/Permission";
import Button from "sushiweb/Button";

const EvQcDetails = (props) => {
  const { feID, evDetails, evAdditionalData } = props;
  const [initialState, setInitialState] = useState(evDetails);
  const [evQcApproved, setEvQcApproved] = useState(
    getPath(evDetails, "qc_status", "") === "qc_success"
  );
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const allActions = MenuActionsMappings[MenuNames.DLRC_CHECK];
  let qcReasons = getPath(evAdditionalData, "ev_qc_reasons", {});

  const getReasonMapping = () => {
    return Object.keys(qcReasons).map((key) => {
      return {
        code: key,
        reason: qcReasons[key],
      };
    });
  };

  useEffect(() => {
    setInitialState(evDetails);
  }, [evDetails]);

  const verifiedOptions = [
    {
      label: "Accept",
      value: "qc_success",
      disabled: evQcApproved,
    },
    {
      label: "Reject",
      value: "verify_failed",
      disabled: evQcApproved,
    },
  ];

  const getVerifiedOptions = () => {
    var localVerifiedOptions = JSON.parse(JSON.stringify(verifiedOptions));
    return localVerifiedOptions;
  };

  const handleCancelClick = () => {
    setInitialState(evDetails);
    setEvQcApproved(getPath(evDetails, "qc_status", "") === "qc_success");
  };

  const handleSaveClick = () => {
    let payload = {
      driver_id: feID,
      model_name: getPath(initialState, "model_name", ""),
      doc_type: getPath(initialState, "doc_type", ""),
      qc_status: getPath(initialState, "qc_status", ""),
      rejection_reason: getPath(initialState, "rejection_reason", ""),
    };
    props.updateEvQcDetails(payload).then((res) => {
      if (res && getPath(res, "status.code", "") === 200) {
        setEvQcApproved(payload.qc_status === "qc_success");
      }
    });
  };

  const handleVerifiedChange = (e) => {
    setInitialState((prevState) => {
      let newState = { ...prevState, qc_status: e };

      if (e === "verify_failed") {
        newState.model_name = "";
        newState.doc_type = "";
      } else if (e === "qc_success") {
        newState.rejection_reason = "";
      }

      return newState;
    });
  };

  const handleRejectionReasonChange = (key, value) => {
    setInitialState((prevState) => {
      return { ...prevState, rejection_reason: value };
    });
  };

  const handleDocumentTypeChange = (key, value) => {
    setInitialState((prevState) => {
      return { ...prevState, doc_type: value };
    });
  };

  const handleModelChange = (value) => {
    if (value) {
      setInitialState((prevState) => {
        return { ...prevState, model_name: value };
      });
    } else {
      setInitialState((prevState) => {
        return { ...prevState, model_name: "" };
      });
    }
  };

  return [
    <div>
      <RightButtons>
        {!evQcApproved && (
          <FlexContainer>
            <Permission requiredPerms={[allActions.WRITE]}>
              <Button
                data-testId="saveEvQcDetail"
                onClick={handleSaveClick}
                className="sushi-btn mr-10"
                disabled={
                  !(
                    (getPath(initialState, "qc_status") === "qc_success" &&
                      getPath(initialState, "model_name", "") &&
                      getPath(initialState, "doc_type", "")) ||
                    (getPath(initialState, "qc_status") === "verify_failed" &&
                      getPath(initialState, "rejection_reason", ""))
                  )
                }
              >
                Save
              </Button>
            </Permission>
            <Button
              data-testId="cancelSavingEvQcDetail"
              onClick={handleCancelClick}
              className="sushi-btn"
              appearance="outline"
            >
              Cancel
            </Button>
          </FlexContainer>
        )}
      </RightButtons>
      <Divider
        orientation="vertical"
        flexItem
        style={{ marginTop: "10px", marginBottom: "20px" }}
      />
      <BorderedBox className="fields-holder mb-40">
        <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
          <Heading>LOW SPEED EV DOC</Heading>
          <Autocomplete
            autoHighlight
            filterSelectedOptions
            onChange={(event, newValue) => {
              handleModelChange(newValue);
            }}
            onClose={() => {
              setIsOpen(false);
            }}
            id="modelsAutoSearch"
            options={getPath(evAdditionalData, "ev_models", [])}
            clearOnEscape
            clearOnBlur
            disableClearable={false}
            disabled={evQcApproved}
            value={getPath(initialState, "model_name", "")}
            onInputChange={(event, newInputValue) => {
              if (newInputValue === "") {
                handleModelChange(null);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select EV model"
                variant="outlined"
                style={{ width: "30%" }}
              />
            )}
          />
          <PaginatedReactDropdown
            options={getPath(evAdditionalData, "doc_type_list", [])}
            showCross={true}
            data-testid="documentTypeDropdown"
            value={getPath(initialState, "doc_type", "")}
            placeholder="Select document type"
            width="30%"
            disabled={evQcApproved}
            id="documentTypeDropdown"
            handleChange={handleDocumentTypeChange}
          />
          <DocImg
            src={getPath(initialState, "image", "")}
            alt="Document Image"
            style={{ width: 500, height: 500 }}
            onClick={() => setShowModal(true)}
          />
          <p>
            Note:
            <br style={{ marginBottom: "10px" }} />
            1. EV type: Low speed -- only
            <br style={{ marginBottom: "10px" }} />
            2. Rental period greater than today
          </p>
          <RadioGroup
            options={getVerifiedOptions()}
            horizontal
            selectedColor={variables.primaryColor}
            selected={getPath(initialState, "qc_status", "")}
            className="sushi-radios"
            name="verifiedOptions"
            onChange={handleVerifiedChange}
          />
          <PaginatedReactDropdown
            options={getReasonMapping()}
            labelKey="reason"
            valueKey="code"
            showCross={true}
            data-testid="rejectionReasonDropdown"
            value={
              getPath(evDetails, "qc_status", "") === "verify_failed"
                ? qcReasons[getPath(initialState, "rejection_reason", "")]
                : ""
            }
            placeholder="Select rejection reason"
            width="30%"
            disabled={evQcApproved}
            id="rejectionReasonDropdown"
            handleChange={handleRejectionReasonChange}
            keyToChange="reason"
          />
        </div>
      </BorderedBox>
    </div>,
    <Modal
      visible={showModal}
      onClose={() => setShowModal(false)}
      type="medium"
      showCloseIcon={true}
      isCentered
      padding="2rem"
      preventFocus
    >
      <img src={getPath(initialState, "image", "")} alt="Document Image" />
    </Modal>,
  ];
};

const RightButtons = styled(FlexContainer)`
  justify-content: flex-end;
`;

export const DocImg = styled.img`
  width: 200px;
  height: 200px;
  border: 2px solid ${variables.black};
  object-fit: contain;
  justify-content: center;
  cursor: ${({ cursor = "pointer" }) => cursor};
`;

const mapDispatchToProps = (dispatch) => ({
  updateEvQcDetails: bindActionCreators(updateEvQcDetails, dispatch),
});

export default connect(null, mapDispatchToProps)(EvQcDetails);
